import { Box, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const HeaderCard = ({
  title,
  value,
}: {
  title: string;
  value: string;
}) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box>
      <Typography
        sx={{
          color: palette.grey,
        }}
        fontSize={'12px'}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          color: palette.textPrimary,
          fontWeight: '700',
        }}
        fontSize={'18px'}
      >
        {value}
      </Typography>
    </Box>
  );
};
